import { absoluteUrl } from '~/utils/seo';

/**
 * The canonical URL of the current page — the single source of truth for both
 * `<link rel="canonical">` (useSetHead) and the `@id`s in the JSON-LD graph.
 * Query strings are intentionally dropped: filtered/sorted/paginated listings
 * canonicalise to their plain page.
 */
export default function useCanonicalUrl(path?: string): string {
    const config = useRuntimeConfig();
    const route = useRoute();

    return absoluteUrl(String(config.public.prodUrl ?? ''), (path ?? route.path).toLowerCase());
}
